module.exports = __webpack_public_path__ + "img/add.bb29cf30.svg";